import { BASE_URL } from "./api";

export const getSponsorImageUrl = ({ userId, sponsorId, imageName }) => {
  if (!userId || !sponsorId || !imageName) {
    return null;
  }

  return `${BASE_URL}/images/${userId}/Sponsor/${sponsorId}/${imageName}.jpg`;
};
